/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Input,
  Spin,
  Card,
  DatePicker,
} from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, RedoOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import { getModelPermission } from 'utils/permission';
import Select from 'components/Select';
import ModalConfirmation from 'components/ModalConfirmation';
import {
  getEstadosGlobales,
  getTipoDeduccionDeNomina,
  getCuentasContables,
  getAcreedores,
} from 'api/catalogos/index';
import {
  getDeducciones,
  postDeduccion,
  deleteDeduccion,
  patchDeduccion,
  getDeduccion,
} from 'api/nominas/deducciones/deducciones';
import { checkToken } from 'api/utils';
import {
  SLUG_PATTERN,
} from 'utils/patterns';
import makeTree from 'utils/makeTreeFromCuentasContables';
import {
  ESTATUS_ACTIVO,
  ESTATUS_CANCELADO,
  ESTATUS_AUTORIZADO,
  ESTATUS_INACTIVO,
} from '../../../utils/constants';
import DeduccionTipoDeEmpleado, { deduccionTipoNominaEmpleadoPermission } from './DeduccionesTiposNominasEmpleados';
import DeduccionTipoDeNomina, { deduccionTipoNominaPermission } from './DeduccionesTiposDeNominas';
import DeduccionSubtipoDeNomina, { deduccionSubtipoNominaPermission } from './DeduccionesSubtiposDeNominas';

export const deduccionPermission = {
  permissionModel: 'deduccion',
  catalogsModels: [],
  tabsModels: [],
};

const { TextArea } = Input;

const Deduccion = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [tiposNominas, setTiposNominas] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const [acreedores, setAcreedores] = useState([]);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [confirmationCancelarVisible, setConfirmationCancelarVisible] = useState(false);
  const [confirmationReactivarVisible, setConfirmationReactivarVisible] = useState(false);
  const [confirmationVisibleEstatus, setConfirmationVisibleEstatus] = useState(false);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);

  const formInstances = [
    form,
  ];

  const getPermissionEmpleados = getModelPermission(
    deduccionTipoNominaEmpleadoPermission.permissionModel,
    deduccionTipoNominaEmpleadoPermission.catalogsModels,
    deduccionTipoNominaEmpleadoPermission.tabsModels,
    false,
  );

  const getPermissionNominas = getModelPermission(
    deduccionTipoNominaPermission.permissionModel,
    deduccionTipoNominaPermission.catalogsModels,
    deduccionTipoNominaPermission.tabsModels,
    false,
  );

  const getPermissionSubtipos = getModelPermission(
    deduccionSubtipoNominaPermission.permissionModel,
    deduccionSubtipoNominaPermission.catalogsModels,
    deduccionSubtipoNominaPermission.tabsModels,
    false,
  );

  const calcularProfundidadMaxima = (arreglo) => {
    let maxProfundidad = 0;
    const calcularProfundidadRecursiva = (nodo, profundidad) => {
      maxProfundidad = Math.max(maxProfundidad, profundidad);
      if (!nodo.children || nodo.children.length === 0) {
        return;
      }
      nodo.children.forEach((hijo) => {
        calcularProfundidadRecursiva(hijo, profundidad + 1);
      });
    };
    arreglo.forEach((nodo) => {
      calcularProfundidadRecursiva(nodo, 1);
    });
    return maxProfundidad;
  };

  const agregarDisabledEnNivelMasProfundo = (arreglo) => {
    const profundidadMaxima = calcularProfundidadMaxima(arreglo);
    const agregarDisabledRecursivo = (nodo, profundidadActual) => {
      if (!nodo.children || nodo.children.length === 0) {
        if (profundidadActual === profundidadMaxima) {
          if (nodo?.tipo === 7) {
            // eslint-disable-next-line no-param-reassign
            nodo.disabled = false;
          } else {
            // eslint-disable-next-line no-param-reassign
            nodo.disabled = true;
          }
          return;
        }
        // eslint-disable-next-line no-param-reassign
        nodo.disabled = true;
        return;
      }
      if (profundidadActual === profundidadMaxima) {
        // eslint-disable-next-line no-param-reassign
        nodo.disabled = false;
      } else {
        // eslint-disable-next-line no-param-reassign
        nodo.disabled = true;
      }
      nodo.children.forEach((hijo) => {
        agregarDisabledRecursivo(hijo, profundidadActual + 1);
      });
    };
    arreglo.forEach((nodo) => {
      agregarDisabledRecursivo(nodo, 1);
    });
  };

  const normalizeCuentasContables = (_data) => {
    if (_data) {
      const output = _data.map((item) => {
        const clone = { ...item };
        const children = normalizeCuentasContables(clone.children);
        const hasCuentasChildren = children.some((e) => e.conac);
        const selectable = clone.tipo !== 7 && !hasCuentasChildren;
        if (!children.length) {
          delete clone.children;
          return ({
            ...clone,
            title: `${clone.clave_visible || clone.clave} - ${clone.nombre}`,
            value: clone.id,
            key: clone.id,
            disabled: !selectable,
          });
        }
        return ({
          ...clone,
          title: `${clone.clave_visible || clone.clave} - ${clone.nombre}`,
          value: clone.id,
          key: clone.id,
          children,
          disabled: !selectable,
        });
      });
      return output;
    }
    return [];
  };

  const flattenWithChildren = (arr) => {
    const flattened = [];
    const traverse = (items) => {
      items.forEach((item) => {
        const { children, ...itemWithoutChildren } = item;
        flattened.push(itemWithoutChildren);
        if (children && children.length > 0) {
          traverse(children);
        }
      });
    };
    traverse(arr);
    return flattened;
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getDeducciones();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _cuentas,
        _tiposNominas,
        _acreedores,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getCuentasContables(),
        getTipoDeduccionDeNomina(),
        getAcreedores(),
        getDeducciones(),
      ]);
      if (mounted) {
        setEstados(_estados);
        const normalizedCuentas = normalizeCuentasContables(makeTree(_cuentas));
        agregarDisabledEnNivelMasProfundo(normalizedCuentas);
        setCuentas(flattenWithChildren(normalizedCuentas));
        setTiposNominas(_tiposNominas);
        setAcreedores(_acreedores);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setEstatusInactivo(false);
    setEstatusAutorizado(false);
    setConfirmationCancelarVisible(false);
    setConfirmationReactivarVisible(false);
    setSelectedRowKeys([]);
    setVisible(false);
    form.resetFields();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _deduccion = await getDeduccion(match.id);
    if (_deduccion?.estados_globales === ESTATUS_ACTIVO
      || _deduccion?.estados_globales === ESTATUS_INACTIVO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_INACTIVO
      || estado?.id === ESTATUS_ACTIVO));
    }
    if (_deduccion?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_AUTORIZADO));
      setEstatusAutorizado(true);
    }
    if (_deduccion?.estados_globales === ESTATUS_INACTIVO) {
      setEstatusInactivo(true);
    }
    setTimeout(() => {
      if (_deduccion) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(_deduccion));
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchDeduccion(key, values) : postDeduccion(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteDeduccion(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    setEstadosFiltered(estados);
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una nómina ya autorizada');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        estados_globales: ESTATUS_AUTORIZADO,
      };
      const res = await patchDeduccion(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishCancelar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const res = await patchDeduccion(key, { estados_globales: ESTATUS_CANCELADO });
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationCancelarVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishReactivar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const res = await patchDeduccion(key, { estados_globales: ESTATUS_ACTIVO });
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationReactivarVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationEstatus = async () => {
    setConfirmationVisibleEstatus(false);
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Clave Anterior',
      dataIndex: 'clave_anterior',
      key: 'clave_anterior',
      width: 200,
    },
    {
      titleText: 'Concepto',
      dataIndex: 'concepto',
      key: 'concepto',
      width: 200,
    },
    {
      titleText: 'Acreedor',
      dataIndex: 'acreedor',
      key: 'acreedor',
      width: 200,
      render: (val) => acreedores.find((e) => e.id === val)?.nombre_comercial,
    },
    {
      titleText: 'Cuenta Contable del Pasivo del Pago de la Nómina',
      dataIndex: 'cuenta_contable',
      key: 'cuenta_contable',
      width: 400,
      render: (val) => {
        const _cuenta = cuentas.find((e) => e.id === val);
        return `${_cuenta?.clave_visible || _cuenta?.clave} - ${_cuenta?.nombre}`;
      },
    },
    {
      titleText: 'Concepto de Deducción del SAT',
      dataIndex: 'tipo_deduccion_nomina',
      key: 'tipo_deduccion_nomina',
      width: 250,
      render: (val) => {
        const _tiposNominas = tiposNominas.find((e) => e.id === val);
        return `${_tiposNominas?.clave} - ${_tiposNominas?.descripcion}`;
      },
    },
    {
      titleText: 'Es Liquidación',
      dataIndex: 'es_deduccion_de_liquidacion',
      key: 'es_deduccion_de_liquidacion',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            titleTable="Deducciones"
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            disableDelete={
              data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
            }
            customActions={[
              {
                onClick: () => setConfirmationVisible(true),
                permission: { model: 'deduccion', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
              },
              {
                onClick: () => setConfirmationCancelarVisible(true),
                permission: { model: 'deduccion', action: 'cancelar' },
                text: 'Cancelar',
                icon: <CloseCircleOutlined />,
                disabledBySelection: false,
                className: 'cancel',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO,
              },
              {
                onClick: () => setConfirmationReactivarVisible(true),
                permission: { model: 'deduccion', action: 'reactivar' },
                text: 'Reactivar',
                icon: <RedoOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_ACTIVO,
              },
            ]}
            permission={permission}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Deducción`}
            extra={(
              <FormSubmitControls
                onFinish={() => form.submit()}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="clave"
                    rules={rules.clave}
                    label="Clave"
                    hasFeedback
                  >
                    <Input
                      allowClear
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="clave_anterior"
                    label="Clave Anterior"
                  >
                    <Input
                      allowClear
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="concepto"
                    rules={rules.required}
                    label="Concepto"
                    hasFeedback
                  >
                    <Input
                      allowClear
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="acreedor"
                    label="Acreedor"
                    rules={rules.estatus}
                    hasFeedback
                  >
                    <Select
                      labelProp="nombre_comercial"
                      keyLabelRender
                      dataSource={acreedores}
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="cuenta_contable"
                    label="Cuenta Contable del Pasivo"
                    rules={rules.estatus}
                    hasFeedback
                  >
                    <Select
                      labelProp="nombre"
                      keyLabelRender
                      dataSource={cuentas}
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_deduccion_nomina"
                    label="Concepto de Deducción del SAT"
                    rules={rules.estatus}
                    hasFeedback
                  >
                    <Select
                      keyLabelRender
                      dataSource={tiposNominas}
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    name="formula"
                    label="Fórmula"
                    hasFeedback
                  >
                    <TextArea
                      disabled={estatusAutorizado || estatusInactivo}
                      allowClear
                      rows={3}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    name="observaciones"
                    label="Observaciones"
                    hasFeedback
                  >
                    <TextArea
                      disabled={estatusAutorizado || estatusInactivo}
                      allowClear
                      rows={3}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="es_deduccion_de_liquidacion"
                    rules={rules.required}
                    label="Es Deducción de Liquidación"
                    hasFeedback
                  >
                    <Select
                      trueFalse
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="aplica_importe_variable_por_evento"
                    rules={rules.required}
                    label="Aplica Importe Variable por Evento"
                    hasFeedback
                    initialValue={false}
                  >
                    <Select
                      trueFalse
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="vigente_al"
                    label="Vigencia Final"
                    hasFeedback
                  >
                    <DatePicker
                      allowClear
                      format="DD/MM/YYYY"
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    rules={rules.estatus}
                    hasFeedback
                    initialValue={1}
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={estadosFiltered}
                      disabled={!selectedRowKeys.length || estatusAutorizado || estatusInactivo}
                      onChange={(val) => {
                        if (val === ESTATUS_INACTIVO) {
                          setConfirmationVisibleEstatus(true);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              {selectedRowKeys.length
                ? (
                  <>
                    <p style={{ fontWeight: 600, marginBottom: 0, color: '#D88F4F' }}>Tipo de Nómina</p>
                    <DeduccionTipoDeNomina
                      permission={getPermissionNominas}
                      selected={selectedRowKeys[0]}
                      estatusInactivo={estatusInactivo}
                    />
                  </>
                ) : null}
              {selectedRowKeys.length
                ? (
                  <>
                    <p style={{ fontWeight: 600, marginBottom: 0, color: '#D88F4F' }}>Tipo de Nómina Empleado</p>
                    <DeduccionTipoDeEmpleado
                      permission={getPermissionEmpleados}
                      selected={selectedRowKeys[0]}
                      estatusInactivo={estatusInactivo}
                    />
                  </>
                ) : null}
              {selectedRowKeys.length
                ? (
                  <>
                    <p style={{ fontWeight: 600, marginBottom: 0, color: '#D88F4F' }}>Subtipo de Nómina</p>
                    <DeduccionSubtipoDeNomina
                      permission={getPermissionSubtipos}
                      selected={selectedRowKeys[0]}
                      estatusInactivo={estatusInactivo}
                    />
                  </>
                ) : null}
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Deducción ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          onFinishText="Continuar"
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          title="Confirmación"
          contentTitle={`Autorizar la Deducción ${form.getFieldValue('concepto')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishCancelar}
          ConfirmCancel
          onCancel={() => {
            setConfirmationCancelarVisible(false);
          }}
          open={confirmationCancelarVisible}
          title="Confirmación"
          contentTitle={`Cancelar la Deducción ${form.getFieldValue('concepto')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishReactivar}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => {
            setConfirmationReactivarVisible(false);
          }}
          open={confirmationReactivarVisible}
          title="Confirmación"
          contentTitle={`Reactivar la Deducción ${form.getFieldValue('concepto')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationEstatus}
          onFinishText="Continuar"
          onCancel={() => {
            setConfirmationVisibleEstatus(false);
            form.setFieldValue('estados_globales', 1);
          }}
          open={confirmationVisibleEstatus}
          title="Confirmación"
          contentTitle={`Inactivar la Deducción ${form.getFieldValue('concepto')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default Deduccion;
